/// <reference path='../_all.ts' />

module navigation {
  'use strict';

  /**
   *
   */
  trackPageViewDirective.$inject = [
    'anchorNavService', 
    'pageMetaService',
    '$timeout',
    '$window',
    '$analytics',
  ];

  export function trackPageViewDirective(
    anchorNavService : IAnchorNavService, 
    pageMetaService: navigation.IPageMetaService,
    $timeout : ng.ITimeoutService,
    $window: ng.IWindowService,
    $analytics : angulartics.IAnalyticsService
    ): ng.IDirective {
    return {
      restrict: 'A',
      scope: {
        trackPageView: '@',
      },
      link: function (scope : any, element: ng.IAugmentedJQuery, attr: ng.IAttributes) {

        element.bind('click', ()=> {
          $analytics.pageTrack(scope.trackPageView);
        });   

      }
    }
  }
}